/*
  File name: messages.js
    Program Description:
    - This file returns the error message when the condition in the validations
    file has not been met.
*/

const getNestedValue = (obj, key) => key.split('.').reduce((acc, curr) => acc[`${curr}`], obj)
const messages = {
  required: ({ fieldName }) => `${fieldName} is required.`,
  minLength: ({ $v, field }) => {
    const val = getNestedValue($v, field)
    const n = val.$params.minLength.min

    return `Must be ${n} characters or longer.`
  },
  maxLength: ({ $v, field }) => {
    const val = getNestedValue($v, field)
    const n = val.$params.maxLength.max

    return `Must be ${n} characters or less.`
  },
  email: () => 'Must be a valid email address.',
  isNameLike: () => 'Must not include special characters.',
  oneOf: () => 'Must be a valid option.',
  alphaNum: () => 'Must be alpha-numeric.',
  numeric: () => 'Must be numeric (0-9) input only',
  decimal: () => 'Must be numbers.',
  $each: () => 'An provided value does not follow the proper format.',
  minValue: () => 'Invalid Value.',
  maxValue: () => 'Invalid Value',
  minDate: () => 'The date is below minimum value required',
  maxDate: ({ fieldName, $v, field }) => {
    const { comparisonName } = getNestedValue($v, field).$params.maxDate
    return comparisonName !== '' ? `${fieldName} cannot be later than the ${comparisonName}` : 'The date is out of maximum value required'
  },
  isYear: () => 'Date must be year only',
  sameName: ({ fieldName }) => `${fieldName} must be unique.`,
  ifExists: ({ fieldName }) => `${fieldName} already exists.`,
  fileSize: ({ $v, field }) => {
    const { max, totalMax } = getNestedValue($v, field).$params.fileSize
    return totalMax ? `Total size of files must be ${max} MB or less.` : `File must be ${max} MB or less.`
  },
  fileFormat: ({ $v, field }) => {
    const { format } = getNestedValue($v, field).$params.fileFormat
    return `File must be in this format: ${format.join(', ')}.`
  },
  exactLength: ({ $v, field }) => {
    const { characters, name } = getNestedValue($v, field).$params.exactLength
    return `Must be ${characters} ${name}.`
  },
  rangeLength: ({ $v, field }) => {
    const { type, min, max } = getNestedValue($v, field).$params.rangeLength
    return `Must be between ${min} and ${max} ${type}.`
  },
  isMaxValue: ({ $v, field }) => {
    const { maxValue, firstField, secondField } = getNestedValue($v, field).$params.isMaxValue
    return `${firstField} must be less than or equal to ${secondField} ${maxValue}.`
  },
  isZeroAmount: ({ fieldName }) => `${fieldName} is required and must not equal to zero`,
  isWhole: () => 'Please enter a valid whole number'
}

export default messages
